/**
 * @desc 分页
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.warehouseSku.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/warehouseSku/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
